import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

const getUrl = (data) => {
	let paramUrl = `date-between-data/relation-with-nitex?supplierId=${data.supplierId}`;
	let chartParamUrl = `year-wise/relation-with-nitex?supplierId=${data.supplierId}`;

	switch (data.type) {
		case 'RELATION':
			if (data.startDate && data.endDate) {
				paramUrl += `&startDate=${data.startDate}&endDate=${data.endDate}`;
			}
			return paramUrl;
		case 'CHART':
			if (data.year) {
				chartParamUrl += `&year=${data.year}`;
			}
			if (data.startDate && data.endDate) {
				chartParamUrl += `&startDate=${data.startDate}&endDate=${data.endDate}`;
			}
			return chartParamUrl;
		case 'MONTHLY_OFFER_QUANTITY':
			return `${data.supplierId}/monthly-offer-qty-by-year/${data.year}`;
		case 'PRODUCT_TAG':
			return `${data.supplierId}/product-tag/${data.tagType}`;
		case 'OCS':
			return `${data.supplierId}/certificates/${data.ocsType}`;
		case 'GALLERY':
			return `photo-documents/${data.supplierId}`;
		default:
			break;
	}
};

export const fetchSupplierData = async (parmas) => {
	try {
		const { data } = await ApiClient.GET('supplierAction', getUrl(parmas));
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onSubmitOfferQuantity = async (offerData) => {
	try {
		const { data } = await ApiClient.POST(
			'supplierAction',
			offerData.body,
			`${offerData.supplierId}/monthly-offer-qty-by-year/${offerData.year}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUpdateSupplierQty = async (parmas) => {
	try {
		const { data } = await ApiClient.PUT(
			'supplierAction',
			'',
			`${parmas.id}/sample-development-${parmas.developmentType}/${parmas.supplierType}?quantity=${parmas.value}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUpdateProductTag = async (supplierId, body) => {
	try {
		const { data } = await ApiClient.PUT('supplierAction', body, `${supplierId}/product-tag-update`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUpdateSpecification = async (supplierId, body) => {
	try {
		const { data } = await ApiClient.PUT('updateSupplierInfo', body, `${supplierId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onAddCertificate = async (supplierId, body) => {
	try {
		const { data } = await ApiClient.POST('addCertificate', body, `${supplierId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUpdateCertificate = async (id, body) => {
	try {
		const { data } = await ApiClient.PUT('updateCertificate', body, `${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onRemoveCertificate = async (id) => {
	try {
		const { data } = await ApiClient.DELETE('supplierAction', {}, `certificate/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onAddGalleryImage = async (supplierId, body) => {
	try {
		const { data } = await ApiClient.POST('addPhotoDocument', body, `${supplierId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onRemovePhoto = async (body) => {
	try {
		const { data } = await ApiClient.DELETE(
			'supplierAction',
			{},
			`photo-document/delete/${body?.id}/${body?.supplierId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchSupplierByMaterialType = async (value = '', materialType = '') => {
	try {
		let params = `?size=1000`;
		if (materialType) {
			params += `&materialType=${materialType}`;
		}
		if (value) {
			params += `&name=${value}`;
		}
		const { data } = await ApiClient.GET('searchSupplier', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const inviteSupplier = async (postData) => {
	try {
		const { data } = await ApiClient.POST('invitePartner', postData);
		return data;
	} catch (e) {
		printApiError(e);
	}
};
